import { render, staticRenderFns } from "./SharedLinkComment.vue?vue&type=template&id=80ed309c&scoped=true"
import script from "./SharedLinkComment.vue?vue&type=script&lang=ts"
export * from "./SharedLinkComment.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkComment.vue?vue&type=style&index=0&id=80ed309c&lang=scss&scoped=true"
import style1 from "./SharedLinkComment.vue?vue&type=style&index=1&id=80ed309c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ed309c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80ed309c')) {
      api.createRecord('80ed309c', component.options)
    } else {
      api.reload('80ed309c', component.options)
    }
    module.hot.accept("./SharedLinkComment.vue?vue&type=template&id=80ed309c&scoped=true", function () {
      api.rerender('80ed309c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SharedLinkComment.vue"
export default component.exports